import {useEffect, useState} from 'react';

export const useSessionState = (
  key: string,
  initial?: string,
): [string | undefined, (v?: string) => void] => {
  const [state, setState] = useState(initial);

  useEffect(() => {
    const value = sessionStorage.getItem(key);
    if (!value) return;
    setState(value);
  }, [key]);

  const set = (v?: string) => {
    if (v === undefined) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, v);
    setState(v);
  };

  return [state, set];
};
